import { useEffect, useState } from 'react';
import { useRouter } from '@tanstack/router';
import { useBillSize } from './useBillSize';
import { useFields } from './useFields';
import { StepName, StepType } from '@/state/state.types';

export const useBeacon = () => {
  const [initialized, setInitialized] = useState(false);
  const { billSizeUnder15k, hasBillSize } = useBillSize();
  const fields = useFields();
  const router = useRouter();

  const currentLocation = router.state.currentLocation.href;

  const email = fields?.email ?? '';
  const firstName = fields?.['first-name'] ?? '';
  const lastName = fields?.['last-name'] ?? '';

  const initBeacon = () => {
    window.Beacon('init', '605973a5-f3b8-4afd-8e48-d1de47602585');
    window.Beacon('config', {
      enableFabAnimation: false,
      display: {
        style: 'icon',
        verticalMobileOffset: 90,
      },
    });
    setInitialized(true);
  };

  const isValidSetp = [
    StepType.open,
    StepType.multi_choice,
    StepType.questionpartial,
    StepType.choice,
    StepName.product,
  ].some((type) => currentLocation.includes(type));

  useEffect(() => {
    if (hasBillSize) {
      if (!initialized && !billSizeUnder15k && !!email && isValidSetp) {
        initBeacon();
      } else if (initialized && !isValidSetp) {
        window.Beacon('destroy');
        setInitialized(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billSizeUnder15k, hasBillSize, email, isValidSetp, initialized]);

  useEffect(() => {
    if (initialized && (!!email || (!!firstName && !!lastName))) {
      window.Beacon('identify', {
        name: !!firstName && !!lastName ? `${firstName} ${lastName}` : '',
        email,
      });
    }
  }, [email, firstName, lastName, initialized]);

  useEffect(() => {
    if (currentLocation && initialized) {
      window.Beacon('session-data', {
        'Current Location': currentLocation,
      });
    }
  }, [currentLocation, initialized]);
};
